module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lPK6t"))).then(() => parcelRequire('hEqeo'));